import axios from "axios";
import { environment } from "../../../environment";
export const url = (bundleId, tradeProposalId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/trade-proposal-bundles/${bundleId}/${tradeProposalId}`
    : `https://middleware.uat.farther.com/investment/trade-proposal-bundles/${bundleId}/${tradeProposalId}`;
export const deleteTradeProposalFromBundle = async (bundleId, tradeProposalId, idempotencyKey, config) => {
    await axios.delete(url(bundleId, tradeProposalId), {
        headers: {
            version: "20241218",
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ["idempotency-key"]: idempotencyKey,
        },
    });
    return;
};
//# sourceMappingURL=deleteTradeProposalFromBundle.js.map